import React from 'react';
import Breadcumb from '../components/Breadcumb';
import SlideBc from '../components/slideBc';
import Footer from '../components/Footer';
import Gallery from 'react-grid-gallery';

const IMAGES =
[
{
    src: 'https://i.imgur.com/kZGgzXV.jpg',
    thumbnail: "https://i.imgur.com/kZGgzXV.jpg",
    thumbnailWidth: 2700,
    thumbnailHeight: 1900,
    caption: "Degustacao"
},
{
    src: 'https://i.imgur.com/PGEbEEg.jpg',
    thumbnail: "https://i.imgur.com/PGEbEEg.jpg",
    thumbnailWidth: 2700,
    thumbnailHeight: 1900,
    caption: "Faixada01"
},

{
    src: 'https://i.imgur.com/21XGOmv.jpg',
    thumbnail: "https://i.imgur.com/21XGOmv.jpg",
    thumbnailWidth: 2700,
    thumbnailHeight: 1700,
    caption: "Faixada02"
},
{
    src: 'https://i.imgur.com/21XGOmv.jpg',
    thumbnail: "https://i.imgur.com/21XGOmv.jpg",
    thumbnailWidth: 2700,
    thumbnailHeight: 1700,
    caption: "Faixada02"
}
]

class Empresa extends React.Component {
    render(){
        return(
            <div>
                <SlideBc/>
                <Breadcumb pageName="Dona Mariquinha"/>
                <div className="container-fluid bgXadrez">
                    <div style={{marginTop:'30'}} className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <br/>
                                <br/>
                                <h1 style={{fontFamily:'Pacifico', color:'white', fontSize:'60px'}}>Dona Mariquinha</h1>
                                <p style={{color:'white'}}>
                                    Toda nossa produção passa por um rigoroso controle de qualidade.<br/>
                                    Hoje, temos em nosso mix mais de 20 itens em grãos.<br/>
                                    A nossa matéria-prima é trazida das melhores regiões do Brasil, para que você receba grãos novinhos, que cozinham<br/>
                                    rápido e até consegue economizar gás. Com essa dedicação toda e trabalho, somos reconhecidos pelos nossos consumidores<br/>
                                    como um produto de total de qualidade. Nossos produtos podem ser encontrados em nossas lojas próprias e também nos<br/>
                                    supermercados do Rio Grande do Norte, principalmente em Natal. Somos parte do seu dia a dia, e vamos trabalhar todo<br/>
                                    dia para melhor lhe atender.<br/>
                                </p>
                            </div>
                            <div className="col-md-6">
                            <br/>
                                <div className="embed-responsive embed-responsive-16by9">
                                    <iframe className="embed-responsive-item" src="https://www.youtube.com/embed/YNpoMXpjq8w?rel=0&amp;controls=0&amp;showinfo=0;autoplay=1&mute=0"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid bgXadrez2">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <Gallery images={IMAGES} enableImageSelection={false} />
                            </div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default Empresa;
